import { NAVBAR_ITEMS } from "../../Components/Navbar/Navbar";

export interface TextItem {
  title: string;
  description: string;
}

export interface ProductItem {
  id: string;
  title: string;
  description: string;
  oldPrice: string;
  newPrice: string;
  chipText: string;
  buttonLabel: string;
  buttonUrl: string;
  imageUrl: string;
  imageAlt: string;
  free: boolean;
  primaryButton: boolean;
}

export interface SizeTableItem {
  mm: number;
  inner: number;
  label: string;
}

export interface FaqItem {
  question: string;
  answer: string;
}

export interface OrderFormContent {
  measurementTitle: string;
  measurementSteps: TextItem[];
  introTitle: string;
  introLead: string;
  productLabel: string;
  productOptions: Array<{ value: string; label: string }>;
  ringCircumferenceLabel: string;
  ringCircumferencePlaceholder: string;
  ringSizeLabel: string;
  ringSizePlaceholder: string;
  fullNameLabel: string;
  fullNamePlaceholder: string;
  emailLabel: string;
  emailPlaceholder: string;
  phoneLabel: string;
  phonePlaceholder: string;
  organizationLabel: string;
  organizationSelectPlaceholder: string;
  organizationLoadingLabel: string;
  organizationErrorPlaceholder: string;
  organizationEmptyPlaceholder: string;
  notesLabel: string;
  notesPlaceholder: string;
  consentLabel: string;
  submitLabel: string;
  sendingLabel: string;
  detailsProductsLabel: string;
  detailsProductsUrl: string;
  requiredFieldsMessage: string;
  consentRequiredMessage: string;
  successMessage: string;
  errorMessage: string;
}

export interface MembriPageContent {
  hero: {
    title: string;
    lead: string;
    primaryCtaLabel: string;
    primaryCtaUrl: string;
  };
  benefits: {
    title: string;
    items: TextItem[];
  };
  smartOffer: {
    title: string;
    lead: string;
    products: ProductItem[];
    footnote: string;
  };
  orderForm: OrderFormContent;
  signupSteps: {
    title: string;
    items: TextItem[];
    primaryCtaLabel: string;
    primaryCtaUrl: string;
    secondaryCtaLabel: string;
    secondaryCtaUrl: string;
  };
  quote: {
    text: string;
  };
  faq: {
    title: string;
    items: FaqItem[];
  };
  help: {
    title: string;
    description: string;
    contactLabel: string;
    contactUrl: string;
    primaryCtaLabel: string;
    primaryCtaUrl: string;
  };
  usageGuide: {
    title: string;
    items: TextItem[];
    storeButtonLabel: string;
    storeButtonUrl: string;
    appButtonLabel: string;
    appButtonUrl: string;
  };
  sizeTable: SizeTableItem[];
}

export const MEMBERS_CONTENT_DOC_PATH = {
  collection: "siteContent",
  id: "membriDeSindicat",
};

export const DEFAULT_MEMBRI_PAGE_CONTENT: MembriPageContent = {
  hero: {
    title: "Membri de sindicat",
    lead:
      "Impreuna aparam drepturile profesionale si cream conditii mai bune de munca. Afla beneficiile, pasii de inscriere si resursele utile pentru membrii SANITAS Bucuresti.",
    primaryCtaLabel: "Inscriere aplicatie",
    primaryCtaUrl: NAVBAR_ITEMS.INSCRIERE_APLICATIE,
  },
  benefits: {
    title: "Beneficii pentru membri",
    items: [
      {
        title: "Reprezentare si negociere",
        description:
          "Reprezentare in dialogul cu angajatorii si autoritatile, negocieri colective pentru drepturi salariale si conditii corecte.",
      },
      {
        title: "Asistenta juridica",
        description:
          "Consultanta si sprijin juridic in problemele de munca: contracte, drepturi, litigii.",
      },
      {
        title: "Informare si training",
        description:
          "Acces la informari periodice, ghiduri, webinarii si instruiri dedicate membrilor.",
      },
      {
        title: "Comunitate si sprijin",
        description:
          "Comunitate activa, proiecte sociale si initiative pentru bunastarea membrilor.",
      },
    ],
  },
  smartOffer: {
    title: "Smart SANITAS",
    lead:
      "Pentru a folosi aplicatia Smart SANITAS ai nevoie de un gadget dedicat (cu serviciu de plata inclus) sau poti opta pentru un card digital gratuit.",
    products: [
      {
        id: "card",
        title: "Card digital (gratuit)",
        description:
          "Daca nu doresti un wearable cu plata, primesti gratuit un card digital personalizat de la organizatia ta pentru acces in aplicatie.",
        oldPrice: "",
        newPrice: "GRATUIT",
        chipText: "Fara serviciu de plata",
        buttonLabel: "Solicita card digital",
        buttonUrl: NAVBAR_ITEMS.INSCRIERE_APLICATIE,
        imageUrl: "",
        imageAlt: "Card digital SANITAS",
        free: true,
        primaryButton: false,
      },
      {
        id: "inel",
        title: "Inel Smart",
        description:
          "Inel inteligent cu serviciu de plata + functii integrate in aplicatie.",
        oldPrice: "499 lei",
        newPrice: "250 lei",
        chipText: "Pret subventionat pt membru de sindicat",
        buttonLabel: "Cumpara de pe flexpayz.ro",
        buttonUrl: "https://www.flexpayz.ro/",
        imageUrl: "",
        imageAlt: "Inel Smart SANITAS",
        free: false,
        primaryButton: true,
      },
      {
        id: "bratara",
        title: "Bratara Smart",
        description:
          "Bratara confortabila cu plata contactless + integrare completa in aplicatie.",
        oldPrice: "625 lei",
        newPrice: "350 lei",
        chipText: "Pret subventionat pt membru de sindicat",
        buttonLabel: "Cumpara de pe flexpayz.ro",
        buttonUrl: "https://www.flexpayz.ro/",
        imageUrl: "",
        imageAlt: "Bratara Smart SANITAS",
        free: false,
        primaryButton: true,
      },
      {
        id: "breloc",
        title: "Breloc Smart",
        description:
          "Breloc rezistent cu plata integrata, mereu la indemana, prins la chei.",
        oldPrice: "499 lei",
        newPrice: "250 lei",
        chipText: "Pret subventionat pt membru de sindicat",
        buttonLabel: "Cumpara de pe flexpayz.ro",
        buttonUrl: "https://www.flexpayz.ro/",
        imageUrl: "",
        imageAlt: "Breloc Smart SANITAS",
        free: false,
        primaryButton: true,
      },
    ],
    footnote:
      "Preturile afisate sunt pentru membri SANITAS. Organizatia subventioneaza o parte din cost, astfel incat tu platesti doar 250 lei pentru wearables cu serviciu de plata.",
  },
  orderForm: {
    measurementTitle: "Ghid de masurare - alege marimea corecta",
    measurementSteps: [
      {
        title: "Pregateste",
        description: "Taie o banda subtire de hartie sau foloseste un snur.",
      },
      {
        title: "Masoara",
        description:
          "Infasoara in jurul degetului si marcheaza punctul unde capetele se intalnesc.",
      },
      {
        title: "Noteaza mm",
        description: "Masoara cu rigla lungimea in milimetri (ex: 56-57 mm).",
      },
      {
        title: "Alege marimea",
        description:
          "Introdu mm mai jos si iti calculam automat marimea potrivita.",
      },
    ],
    introTitle:
      "Prin completarea acestui formular, finalizezi procesul de inscriere in aplicatia Smart Sanitas. Gadgetul va fi ridicat prin liderul organizatiei tale.",
    introLead:
      "Completeaza formularul pentru a primi gratuit Cardul digital Smart SANITAS, oferit membrilor pentru acces la servicii si beneficii. Daca doresti o versiune extinsa, cu functii suplimentare (inel, bratara sau breloc Smart SANITAS), o poti selecta din meniu - aceste variante sunt disponibile contra cost.",
    productLabel: "Produs",
    productOptions: [
      { value: "card", label: "Card digital (GRATUIT)" },
      { value: "breloc", label: "Breloc Smart (Pret subventionat)" },
      { value: "inel", label: "Inel Smart (Pret subventionat)" },
      { value: "bratara", label: "Bratara Smart (Pret subventionat)" },
    ],
    ringCircumferenceLabel: "Circumferinta deget in caz in care alegi un inel (mm)",
    ringCircumferencePlaceholder: "Ex: 56.5",
    ringSizeLabel: "Marime recomandata",
    ringSizePlaceholder: "Se calculeaza automat",
    fullNameLabel: "Nume complet *",
    fullNamePlaceholder: "Nume si prenume",
    emailLabel: "Email *",
    emailPlaceholder: "exemplu@domeniu.ro",
    phoneLabel: "Telefon *",
    phonePlaceholder: "07xx xxx xxx",
    organizationLabel: "Organizatie / Unitate *",
    organizationSelectPlaceholder: "Selecteaza institutia",
    organizationLoadingLabel: "Se incarca institutiile...",
    organizationErrorPlaceholder: "Eroare la incarcarea listelor - introdu manual",
    organizationEmptyPlaceholder: "Nu exista institutii - introdu manual",
    notesLabel: "Observatii (optional)",
    notesPlaceholder: "Alte informatii utile",
    consentLabel:
      "Sunt de acord cu prelucrarea datelor personale pentru procesarea comenzii (GDPR).",
    submitLabel: "Trimite comanda",
    sendingLabel: "Se trimite...",
    detailsProductsLabel: "Vezi detalii produse",
    detailsProductsUrl: "https://www.flexpayz.ro/",
    requiredFieldsMessage: "Te rugam sa completezi campurile obligatorii.",
    consentRequiredMessage:
      "Trebuie sa iti exprimi acordul privind prelucrarea datelor.",
    successMessage: "Comanda a fost trimisa. Te vom contacta in curand.",
    errorMessage: "A aparut o eroare. Incearca din nou.",
  },
  signupSteps: {
    title: "Cum te inscrii",
    items: [
      {
        title: "Completeaza cererea",
        description:
          "Descarca modelul sau foloseste butonul Inscriere aplicatie. Completeaza datele corect.",
      },
      {
        title: "Depune documentele",
        description:
          "Transmite cererea la reprezentantul SANITAS din unitatea ta sau incarca documentele in aplicatie.",
      },
      {
        title: "Confirmarea calitatii de membru",
        description:
          "Primesti confirmarea si poti accesa beneficiile dedicate.",
      },
      {
        title: "Conecteaza-te in aplicatie",
        description:
          "Urmareste noutati, comunicate, evenimente si resurse juridice direct din contul tau.",
      },
    ],
    primaryCtaLabel: "Inscriere aplicatie",
    primaryCtaUrl: NAVBAR_ITEMS.INSCRIERE_APLICATIE,
    secondaryCtaLabel: "Ai intrebari? Contacteaza-ne",
    secondaryCtaUrl: "/contact",
  },
  quote: {
    text:
      "Impreuna suntem mai puternici. Alatura-te si fa parte din vocea colectiva a profesionistilor din sanatate.",
  },
  faq: {
    title: "Intrebari frecvente",
    items: [
      {
        question: "Care sunt conditiile de inscriere?",
        answer:
          "Pot deveni membri angajatii din domeniul sanitar din Bucuresti care accepta statutul si regulamentele organizatiei.",
      },
      {
        question: "Cum platesc cotizatia?",
        answer:
          "Cotizatia poate fi retinuta direct din salariu conform optiunii exprimate in cerere sau achitata prin metodele comunicate de organizatie.",
      },
      {
        question: "Unde gasesc informatii juridice?",
        answer:
          "Viziteaza sectiunea Juridic -> Legislatie sau contacteaza departamentul juridic pentru situatii specifice.",
      },
    ],
  },
  help: {
    title: "Ai nevoie de ajutor?",
    description:
      "Echipa noastra te sprijina cu informatii despre inscriere, statut, drepturi si obligatii. Scrie-ne sau programeaza o discutie.",
    contactLabel: "Contact",
    contactUrl: "/contact",
    primaryCtaLabel: "Inscriere aplicatie",
    primaryCtaUrl: NAVBAR_ITEMS.INSCRIERE_APLICATIE,
  },
  usageGuide: {
    title: "Ghid de utilizare - Smart SANITAS",
    items: [
      {
        title: "Comanda sau solicita acces",
        description:
          "Alege un gadget (inel, bratara, breloc) sau solicita cardul digital gratuit.",
      },
      {
        title: "Activeaza in aplicatie",
        description: "Primesti instructiuni de activare.",
      },
      {
        title: "Configureaza platile (optional)",
        description: "Adauga metoda de plata in aplicatie.",
      },
      {
        title: "Foloseste beneficiile",
        description:
          "Acceseaza noutati, legitimatie digitala si oferte disponibile pentru membri.",
      },
    ],
    storeButtonLabel: "Mergi la magazin (flexpayz.ro)",
    storeButtonUrl: "https://www.flexpayz.ro/",
    appButtonLabel: "Inscriere aplicatie",
    appButtonUrl: NAVBAR_ITEMS.INSCRIERE_APLICATIE,
  },
  sizeTable: [
    { mm: 50, inner: 16.0, label: "6" },
    { mm: 53, inner: 16.9, label: "7" },
    { mm: 56, inner: 17.8, label: "8" },
    { mm: 59, inner: 18.8, label: "9" },
    { mm: 62, inner: 19.7, label: "10" },
    { mm: 65, inner: 20.7, label: "11" },
    { mm: 68, inner: 21.6, label: "12" },
    { mm: 71, inner: 22.6, label: "13" },
    { mm: 74, inner: 23.5, label: "14" },
  ],
};

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

export function mergeMembriContent(
  base: MembriPageContent,
  patch?: Partial<MembriPageContent>
): MembriPageContent {
  if (!patch) {
    return base;
  }

  const mergeValue = (left: unknown, right: unknown): unknown => {
    if (right === undefined) {
      return left;
    }

    if (Array.isArray(left) && Array.isArray(right)) {
      return right;
    }

    if (isRecord(left) && isRecord(right)) {
      const result: Record<string, unknown> = { ...left };
      Object.keys(right).forEach((key) => {
        result[key] = mergeValue((left as Record<string, unknown>)[key], right[key]);
      });
      return result;
    }

    return right;
  };

  return mergeValue(base, patch) as MembriPageContent;
}
